module.exports = __webpack_public_path__ + "static/img/temp.8821177.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/temp.png
// module id = 5TOc
// module chunks = 38